import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanCareerPathService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  getPlanPathSummary(): Observable<any> {
    return this.get<any>('plan-career-path');
  }
}
